import React from "react";

const PinLocation = (props) => {
  const { tolat, tolng, fromlat, fromlng, droplat, droplng } = props;
  const src = `https://www.google.com/maps/embed/v1/directions?key=AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ&origin=${fromlat},${fromlng}&destination=${tolat},${tolng}&waypoints=${droplat},${droplng}`;

  return (
    <div className="location_wrapper">
      <iframe
        src={src}
        width="100%"
        height="450"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default PinLocation;
